import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/upload.png'


const _withScopeId = n => (_pushScopeId("data-v-78d61f80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base_info_content_bg" }
const _hoisted_2 = { class: "upload-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "*", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "*支持图片格式文件", -1))
const _hoisted_7 = { class: "base_info_content" }
const _hoisted_8 = { class: "input-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "名称", -1))
const _hoisted_10 = { class: "input-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "*2-8个中文字符或4-16个英文字符", -1))
const _hoisted_12 = { class: "phone_number_message_bg" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "电话", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "leave_message_tips" }, "留言", -1))
const _hoisted_15 = { class: "input-wrapper input_wrapper_tag" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "标签", -1))
const _hoisted_17 = { class: "input-content label_info_content" }
const _hoisted_18 = { class: "label_input_bg" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "*4个中文字符或8个英文字符", -1))
const _hoisted_20 = { class: "input-wrapper" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "主题", -1))
const _hoisted_22 = { class: "subject_selection_bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_upload, {
        action: "",
        class: "uploader",
        drag: "",
        accept: "image/png,image/jpeg",
        "on-error": _ctx.handleError,
        "on-success": _ctx.handleSuccess,
        "http-request": (item) => _ctx.uploadImg(item.file),
        "before-upload": _ctx.beforeUPload,
        "show-file-list": false
      }, {
        default: _withCtx(() => [
          (_ctx.baseInfo.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.baseInfo.icon,
                alt: ""
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ]),
        _: 1
      }, 8, ["on-error", "on-success", "http-request", "before-upload"]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.baseInfo.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.baseInfo.name) = $event)),
            onInput: _ctx.checkNameInputLength,
            onChange: _ctx.checkNameInputChange
          }, null, 8, ["modelValue", "onInput", "onChange"]),
          _hoisted_11
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_el_switch, {
          width: "80",
          class: "phone_number_witch",
          modelValue: _ctx.operation.phoneOpen,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.operation.phoneOpen) = $event)),
          onChange: _ctx.phoneOpenSwitchClick,
          "active-color": "rgb(0,0,0,0)",
          "inactive-color": "rgb(0,0,0,0)"
        }, null, 8, ["modelValue", "onChange"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            class: _normalizeClass([!_ctx.operation.phoneOpen ? 'disable_input_bg' : '']),
            modelValue: _ctx.tempPhone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tempPhone) = $event)),
            maxlength: "11",
            disabled: !_ctx.operation.phoneOpen,
            onChange: _ctx.phoneInputChange
          }, null, 8, ["class", "modelValue", "disabled", "onChange"])
        ]),
        _hoisted_14,
        _createVNode(_component_el_switch, {
          width: "80",
          class: "message_witch",
          modelValue: _ctx.operation.messageOpen,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.operation.messageOpen) = $event)),
          "active-color": "rgb(0,0,0,0)",
          "inactive-color": "rgb(0,0,0,0)"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_input, {
              placeholder: "请输入标签",
              modelValue: _ctx.baseInfo.labelName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.baseInfo.labelName) = $event)),
              onInput: _ctx.checkLabelInputLength,
              onChange: _ctx.checkLabelInputChange
            }, null, 8, ["modelValue", "onInput", "onChange"]),
            _hoisted_19
          ]),
          _createVNode(_component_el_select, {
            class: "el-select-option-info",
            modelValue: _ctx.baseInfo.labelValue1,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.baseInfo.labelValue1) = $event)),
            placeholder: "请选择",
            onChange: _ctx.tagsSelectChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelList, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_select, {
            class: "el-select-option-info",
            modelValue: _ctx.baseInfo.labelValue2,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.baseInfo.labelValue2) = $event)),
            placeholder: "请选择",
            onChange: _ctx.tagsSelectChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelList, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_button, {
            class: _normalizeClass(['tab_button', _ctx.baseInfo.style == 'card' ? 'tab_button_selected' : 'tab_button_normal']),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.subjectTabClick(0)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("名片主题")
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_button, {
            class: _normalizeClass(['tab_button', _ctx.baseInfo.style == 'chat' ? 'tab_button_selected' : 'tab_button_normal']),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.subjectTabClick(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("对话主题")
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ])
  ]))
}